var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from "../icon";
import { COLORS } from "../color";
var ButtonLink = /** @class */ (function (_super) {
    __extends(ButtonLink, _super);
    function ButtonLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ButtonLink.prototype.render = function () {
        var _a = this.props, color = _a.color, size = _a.size, style = _a.style, className = _a.className, href = _a.href, to = _a.to, iconPath = _a.iconPath, iconPosition = _a.iconPosition, id = _a.id, disabled = _a.disabled, resizeInMobileResolution = _a.resizeInMobileResolution, hover = _a.hover, isRoundedButton = _a.isRoundedButton, outline = _a.outline;
        style = outline ? 'outline' : style;
        var classNameResult = "gr-btn " + (color || 'primary') + " " + (size || 'md') + " " + (iconPosition === 'right' ? 'icon-right' : 'icon-left') + " " + (resizeInMobileResolution ? 'resize-in-mobile' : '') + " " + (style || '') + " " + (disabled && 'disabled') + " " + (hover ? 'hover-' + hover : '') + " " + (isRoundedButton ? ' btn-border ' : '') + " " + (className || '');
        if (disabled) {
            return (React.createElement("span", { className: classNameResult, id: id },
                React.createElement("span", { className: 'button-container' },
                    iconPath && React.createElement(Icon, { path: iconPath, color: COLORS.gray700 }),
                    React.createElement("span", { className: 'button-content' }, this.props.children))));
        }
        if (to) {
            return (React.createElement(Link, { to: to, className: classNameResult, id: id },
                React.createElement("span", { className: 'button-container' },
                    iconPath && React.createElement(Icon, { path: iconPath, color: COLORS.gray700 }),
                    React.createElement("span", { className: 'button-content' }, this.props.children))));
        }
        else if (href) {
            return (React.createElement("a", { href: href, className: classNameResult, id: id },
                React.createElement("span", { className: 'button-container' },
                    iconPath && React.createElement(Icon, { path: iconPath, color: COLORS.gray700 }),
                    React.createElement("span", { className: 'button-content' }, this.props.children))));
        }
    };
    return ButtonLink;
}(Component));
export { ButtonLink };
//# sourceMappingURL=ButtonLink.js.map